export default __webpack_public_path__ + "static/media/babadook.5a9070ef.jfif";